import { ViewModelForm, useDataRefresh } from 'gw-portals-viewmodel-react';
import React, {
    useCallback
} from 'react';
import { withRouter } from 'react-router-dom';
import { useValidation } from 'gw-portals-validation-react';
import _ from 'lodash';
import metadata from './NagDetail_AX.metadata.json5';

// eslint-disable-next-line camelcase
function NagDetail_AX(props) {
    const {
        data,
        allNags,
    } = props;

    const { isComponentValid, onValidate } = useValidation('componentContent');
    const { refreshData } = useDataRefresh();

    const handleNagChange = useCallback((newModel) => {
        const nag = _.filter(allNags, (item) => (_.isEqual(item.id, newModel.id)));
        if (!_.isUndefined(nag)) {
            const nagUpdate = _.set(nag, newModel);
        }
        refreshData();
    }, [allNags, refreshData]);

    const overrides = {
        '@field': {
            showOptional: true,
            labelPosition: 'left'
        },
        nagKey: {
            readOnly: !data.canEdit
        },
        addNag: {
            disabled: !isComponentValid
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate: onValidate
        }
    };
    return (
        <>
            <ViewModelForm
                uiProps={metadata.componentContent.content}
                model={data}
                onValidationChange={onValidate}
                onModelChange={handleNagChange}
                overrideProps={overrides}
                callbackMap={resolvers.resolveCallbackMap}
            />
        </>
    );
}

export default withRouter(NagDetail_AX);
